module.exports = __webpack_public_path__ + "img/59_13.37c02948.png";